import React from "react";
import styled from "styled-components";
import { get } from "lodash";
import PrismicRichText from "../components/PrismicRichText";
import * as colors from "../constants/colors";

const StlRoot = styled.section`
  padding: 40px 16px 20px;
  @media (min-width: 900px) {
    padding: 56px 56px 32px 56px;
  }
`;

const StlInner = styled.div`
  max-width: 1400px;
  margin: 0 auto;
`;

const StlGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  justify-content: center;

  @media (min-width: 900px) {
    grid-template-columns: repeat(
      ${({ $desktopColumns }) => $desktopColumns},
      minmax(0, 330px)
    );
    gap: 32px;
  }
`;

const StlCard = styled.article`
  border: 1px solid ${colors.gray4};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 16px;
  text-align: center;
  gap: 12px;
  border-radius: 6px;
  @media (min-width: 1100px) {
    min-height: 200px;
    justify-content: space-around;
  }
`;

const StlImageWrap = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 1100px) {
    height: 100px;
    width: 100px;
  }
`;

const StlImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const StlCopy = styled.div`
  color: ${colors.textDark};
  font-size: 14px;
  line-height: 18px;
  h4 {
    margin: 0 auto;
  }

  p {
    margin: 0;
  }
`;

const renderCopy = (item) => {
  const richCopy = get(item, "copy");
  const plainCopy = get(item, "copy_text");

  if (Array.isArray(richCopy) && richCopy.length) {
    return <PrismicRichText render={richCopy} />;
  }

  if (plainCopy) {
    return <p>{plainCopy}</p>;
  }

  return <p>Placeholder copy</p>;
};

const getDesktopColumns = (itemCount) => {
  if (itemCount % 3 === 0) {
    return 3;
  }

  if (itemCount % 4 === 0) {
    return 4;
  }

  return Math.min(itemCount, 3);
};

const InfoBlocks = (slice) => {
  const items = slice?.items || [];

  if (!items.length) {
    return null;
  }

  return (
    <StlRoot
      style={{
        background: get(slice, "primary.background_color", colors.white),
        color: get(slice, "primary.text_color", colors.textDark),
      }}
    >
      <StlInner>
        <StlGrid $desktopColumns={getDesktopColumns(items.length)}>
          {items.map((item, index) => {
            const imageUrl = get(item, "image.url");
            const imageAlt = get(item, "image.alt", "");

            return (
              <StlCard key={`info-block-${index}`}>
                <StlImageWrap>
                  <StlImage src={imageUrl} alt={imageAlt} />
                </StlImageWrap>
                <StlCopy>{renderCopy(item)}</StlCopy>
              </StlCard>
            );
          })}
        </StlGrid>
      </StlInner>
    </StlRoot>
  );
};

export default InfoBlocks;
